import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ButtonProps, Dialog } from '@optimus-web/core';

export const UNSAVED_CHANGES_DIALOG_NAME = 'unsavedChanges';

interface UnsavedChangesDialogProps {
    content?: React.ReactNode;
    onCancel: () => void;
    onDiscardChanges: () => void;
    active?: boolean;
}

export const UnsavedChangesDialog = ({
    active = true,
    content,
    onCancel,
    onDiscardChanges,
}: UnsavedChangesDialogProps) => {
    const actions: ButtonProps[] = [
        {
            children: <LocalizedText textKey={TextKey.UnsavedChangesCancel} />,
            onClick: onDiscardChanges,
            variant: 'tertiary',
            size: 'medium',
            type: 'submit',
            'data-test-id': 'unsaved-changes-dialog-discard-changes-button',
        },
        {
            children: <LocalizedText textKey={TextKey.UnsavedChangesConfirm} />,
            onClick: onCancel,
            variant: 'primary',
            size: 'medium',
            type: 'submit',
            'data-test-id': 'unsaved-changes-dialog-cancel-button',
        },
    ];

    return (
        <Dialog
            active={active}
            title={<LocalizedText textKey={TextKey.UnsavedChangesTitle} />}
            actions={actions}
            onClose={onCancel}
        >
            <div data-test-id="unsaved-changes-dialog-content">
                {content || <LocalizedText textKey={TextKey.UnsavedChangesContent} />}
            </div>
        </Dialog>
    );
};
